import React from "react";
import "./intro.scss";
import { Jumbotron, Container } from "react-bootstrap";
import { Link } from "react-scroll";

const Intro = () => {
  return (
    <section id="intro">
      <Jumbotron className="text-center">
        <Container>
          <h1>Noches De Salsa</h1>
          <h2>Cuban salsa classes in Blackpool and Fylde</h2>

          <Link
            className="btn btn-outline-secondary btn-lg mt-3"
            to="about"
            spy
            smooth
            offset={-69}
            duration={500}
          >
            Learn More
          </Link>
        </Container>
      </Jumbotron>
    </section>
  );
};

export default Intro;
